import classNames from 'classnames';
import Link from 'next/link';

import { getButtonClassName } from './helpers';
import { ButtonStyleProps } from './types';
import { convertHref } from '../../utils/convertHref';
import Caret from '../icons/Caret';
import { AppLinkProps } from '../Text/TextLink';

import style from './button-link.module.css';

type LinkButtonProps = AppLinkProps & ButtonStyleProps;

const ButtonLink = ({
  buttonColor,
  caretProps,
  hideCaret,
  linkFragment,
  variant,
  ...linkProps
}: LinkButtonProps) => {
  const buttonClassName = getButtonClassName({
    buttonColor,
    variant,
  });

  if (!linkFragment) {
    return null;
  }

  return (
    <Link
      {...linkProps}
      className={classNames(
        buttonClassName,
        linkProps.className,
        style.buttonLink,
      )}
      href={convertHref(linkFragment.url)}
      target={linkFragment.target ?? undefined}
    >
      {linkFragment.title}

      {!hideCaret && <Caret {...caretProps} />}
    </Link>
  );
};

export default ButtonLink;
